import { createContext, useContext } from 'react';
import { InsurancePolicy } from '../../../interfaces/InsurancePolicy';
import { InsuranceAppendix } from '../../../interfaces/InsuranceAppendix';
import { Client } from '../../../interfaces/Client';
import { Company } from '../../../interfaces/Company';

interface ProductsContextData {
    insurancePolicies: InsurancePolicy[];
    setInsurancePolicies: (insurancePolicies: InsurancePolicy[]) => void;
    createInsuranceProduct: (newInsurancePolicy: InsurancePolicy, originalPolicyId?: string) => Promise<void>;
    client: Client;
    consts: {
        InsuranceRecommendation: string[];
        RecommendationReasons: string[];
        companies: Company[];
        familyMembers: any[];
    };
    initiallyExpandedRows: string[];
    setInitiallyExpandedRows: React.Dispatch<React.SetStateAction<string[]>>;
}

export const ProductsContext = createContext<ProductsContextData | undefined>(undefined);

export function useProductsContext() {
    const context = useContext(ProductsContext);
    if (!context) {
        throw new Error('useProductsContext must be used within a ProductsContext.Provider');
    }
    return context;
}
